import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // 编辑基本信息
  async getFileToken(params) {
    return request({
      method: GET,
      url: `/member/file/applyDownLoadNode/${params.id}`,
    })
  },
}
